import one from '../assets/img/roadmap/one.svg';
import two from '../assets/img/roadmap/two.svg';
import three from '../assets/img/roadmap/three.svg';
import four from '../assets/img/roadmap/four.svg';
import five from '../assets/img/roadmap/five.svg';

export const headerData = {
	navigation: [
		{ title: 'Advantages', id: '#advantages' },
		{ title: 'Why Sevn', id: '#why-sevn' },
		{ title: 'Roadmap', id: '#roadmap' },
	],
};

export const advantagesData = {
	titles: ['Best liquidity for GamiFi', 'Most profitable pools', 'Dashboard'],
	descriptions: [
		'Trade utility tokens of gaming projects with lowest slippage and transaction costs',
		'Earn more with farmming pools with highest APR for gaming projects',
		'Simple way to track your earnings from all sources on Sevn',
	],
};

export const whyData = {
	titles: ['Dividends', 'Token Airdrops', 'Fee Reduction'],
	descriptions: [
		'Earn part of the Dex profit by staking your Sevn',
		'Participate in airdrops on newly listed tokens by holding Sevn',
		'Hold Sevn and trade with grate discount',
	],
};

export const roadmapData = {
	cardsData: [
		{
			image: one,
			title: 'Q3 2022',
			steps: ['Concept and design ', 'Website launch', 'Testnet campaign', 'Security audit'],
		},
		{
			image: two,
			title: 'Q4 2022',
			steps: ['Dex Launch', 'Strategic Partnership', 'BNB Chain integration'],
		},
		{
			image: three,
			title: 'Q1 2023',
			steps: ['P2P Trading', 'Avalanche Integration', 'Polygon Integration'],
		},
		{
			image: four,
			title: 'Q2 2023',
			steps: ['Gasless Trading', 'Crosschain Swaps Integration', 'First GemiFi Index'],
		},
		{
			image: five,
			title: 'Q3 2023',
			steps: ['Gaming Project Incubator', 'Crowdfunding Platform', 'Liquidity Aggregator'],
		},
	],
};

export const links = {
	telegram: '#',
	twitter: '#',
	medium: '#',
	discord: '#',
	app: '#',
};
